import React from 'react';
import { faDice } from '@fortawesome/free-solid-svg-icons';
import { useLocationContext } from '../../hooks/useLocationContext';
import { createListSection } from '../ListSection';
import { SectionItem } from '../SectionItem';
import { Highlight } from '../Highlight';
function CasinoElement({ value, highlights, position }) {
    const { urlService } = useLocationContext();
    // TODO: Support different devices?
    const href = urlService === null || urlService === void 0 ? void 0 : urlService.getCasinoLauncherUrl(`${value.presentationCode}?channel=mobile&owningVertical=Gaming`);
    const id = value.id;
    const searchSection = 'Gaming';
    return (React.createElement(SectionItem, { className: "WhSearch-SectionItem--bigIcon", expectedTitle: 2, expectedDescription: 1, cutTitle: 2, cutDescription: 1, internalLink: true, href: href, icon: value.thumbnailUrl || faDice, id: id, searchSection: searchSection, position: position, isCasino: true },
        React.createElement("div", { className: "WhSearch-SectionItem__title" },
            React.createElement(Highlight, { highlighted: highlights.title, content: value.title })),
        React.createElement("div", { className: "WhSearch-SectionItem__description" },
            React.createElement(Highlight, { highlighted: highlights.category, content: value.category }),
            " |",
            ' ',
            React.createElement(Highlight, { highlighted: highlights.provider, content: value.provider }))));
}
export const CasinoSection = createListSection(CasinoElement, {
    title: 'sectionCasinoGamesTitle',
});
//# sourceMappingURL=CasinoSection.js.map